import script from "./StorageRequestDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./StorageRequestDialog.vue?vue&type=script&setup=true&lang=ts"

import "./StorageRequestDialog.vue?vue&type=style&index=0&id=883acd30&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-883acd30"]])

export default __exports__